import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags as t } from '@lezer/highlight';
import { parser } from './fortigate-parser.js';

const fortigateLanguage = LRLanguage.define({
  parser: parser.configure({
    props: [
      styleTags({
        config: t.controlKeyword,
        edit: t.controlKeyword,
        set: t.meta,
        end: t.controlKeyword,
        next: t.controlKeyword,
        'PropertyName/Identifier': t.propertyName,
        'ConfigPath/Identifier': t.typeName,
        'Value/Identifier': t.variableName,
        SpecialValue: t.bool,
        Number: t.number,
        'IpPrefix/Number': t.number,
        'Ipv6Prefix/Number': t.number,
        String: t.string,
        IpAddress: t.atom,
        Ipv6Address: t.atom,
        '"/"': t.operator,
        LineComment: t.lineComment
      })
    ]
  }),
  languageData: {
    commentTokens: { line: '#' }
  }
});

export function fortigate() {
  return new LanguageSupport(fortigateLanguage);
}
